<template>
    <div class="recap-page">
        <h1 class="recap-page__title">{{ $t.__('recap.title') }}</h1>
        <CompassButton
            :label="$t.__('common.actions.leave')"
            class="recap-page__leave-button"
            type="tertiary-contrast"
            leftIcon="close"
            @click="handleLeave"
        />
        <RecapSlider />
    </div>
</template>
<script>
import RecapSlider from 'vcomponents/recap/RecapSlider.vue';

export default {
    name: 'RecapPage',
    components: {
        RecapSlider,
    },
    methods: {
        handleLeave() {
            this.$router.push({ name: 'dashboard' });
        },
    },
};
</script>
<style lang="scss">
body:has(.recap-page) {
    .global {
        background: var(--colors-common-background-darkest-default);
    }

    .navbar-brand,
    .contentMenu,
    .menuWithoutText .el-collapse-item__header {
        box-shadow: -1px 0 0 0 var(--colors-component-background-sidebar-hover) inset;
    }
}
</style>
<style lang="scss" scoped>
.recap-page {
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 12px 40px 100px;
    position: relative;

    &__title {
        font-family: var(--font-families-stack-sans-text), sans-serif;
        font-size: var(--font-size-17);
        font-weight: var(--font-weights-stack-sans-text-4);
        letter-spacing: 2px;
        line-height: var(--line-heights-50);
        margin: 0 0 21px;
        text-transform: uppercase;

        background: linear-gradient(90deg, #fdf1de 0%, #4868fd 46.5%, #7f95fe 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    &__leave-button {
        position: absolute;
        right: 6px;
        top: 0;
    }
}
</style>
